import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Flashcard from '../components/Flashcards';
import Quiz from '../components/Quiz';
import MyDecks from '../components/MyDecks';
import MyClasses from '../components/MyClasses';
import { useNavigate } from 'react-router-dom';
import AIDeckGenerator from './AIDeckGenerator';
import CustomTimeline from '../components/CustomTimeline';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useTranslation } from 'react-i18next';
import LanguageSelector from '../components/LanguageSelector';
import { isGuest, setGuest } from '../utils/guest';

const StudentDashboard = ({ setUser, setActiveRole }) => {
  const [activeTab, setActiveTab] = useState(() => localStorage.getItem('studentActiveTab') || 'aiDeck');
  const [timelineEvents, setTimelineEvents] = useState([]);
  const [showHelp, setShowHelp] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const user = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    const parsedUser = storedUser ? JSON.parse(storedUser) : null;

    if (!parsedUser && !isGuest()) {
      navigate('/login');
    } else {
      setGuest(!parsedUser);
      setIsReady(true);
    }
  }, []);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const res = await axios.get('/events.json');
        setTimelineEvents(res.data);
      } catch (err) {
        console.error('Failed to load timeline events:', err);
      }
    };
    fetchEvents();
  }, []);

  useEffect(() => {
    localStorage.setItem('studentActiveTab', activeTab);
  }, [activeTab]);

  const roles = user?.roles || [user?.role];
  const activeRole = localStorage.getItem('activeRole');

  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('activeRole');
    setUser(null);
    setActiveRole(null);
    navigate('/');
  };

  const handleSwitchRole = () => {
    const newRole = roles.find((r) => r !== activeRole);
    localStorage.setItem('activeRole', newRole);
    setActiveRole(newRole);
    navigate(newRole === 'teacher' ? '/teacher' : '/student-dashboard');
  };

  if (!isReady) return null;

  const GuestOverlay = () => (
    <div className="absolute inset-0 bg-white bg-opacity-95 flex items-center justify-center z-40 text-black">
      <div className="border border-black p-6 text-center max-w-md">
        Want to save and edit your work? <br />
        <button onClick={() => navigate('/login')} className="underline mt-2 inline-block">
          Sign in
        </button>
      </div>
    </div>
  );

  return (
    <div className="flex min-h-screen bg-white text-black relative">
      <div className="absolute top-4 right-6 flex gap-4 items-center z-50">
         {/* <LanguageSelector /> */}
        <button onClick={() => setShowHelp(!showHelp)} className="border border-black px-2 py-1 text-sm">
          Help
        </button>
        {showHelp && (
          <div className="absolute top-full mt-2 right-0 w-80 border border-black bg-white text-black p-4 z-50">
            <h3 className="font-bold mb-2 uppercase text-sm">Help</h3>
            <p className="text-sm whitespace-pre-line">{t(`help.${activeTab}`)}</p>
          </div>
        )}
        <button onClick={handleLogout} className="border border-black px-4 py-1 text-sm">
          Logout
        </button>
        <ToastContainer position="top-right" autoClose={2000} />
      </div>

      <div className="w-60 border-r border-black p-6 space-y-4">
        <h2 className="text-xl font-bold mb-6 uppercase">
         Welcome back, {user?.name?.split(' ')[0] || 'Student'}
        </h2>

        {[
  ['aiDeck', 'Explore'],
  ['customTimeline', 'My Studies'],
   ['myDecks', 'My Collections'],
  // ['flashcards', 'Flashcards'],
  // ['quiz', 'Quiz'],
].map(([key, label]) => (
          <button
            key={key}
            onClick={() => setActiveTab(key)}
            className={`w-full text-left px-4 py-2 border border-black text-sm uppercase ${activeTab === key ? 'bg-black text-white' : 'bg-white text-black'}`}
          >
            {label}
          </button>
        ))}
      </div>

      <div className="flex-1 p-6 overflow-y-auto relative">
  {activeTab === 'aiDeck' && <AIDeckGenerator />}
  {activeTab === 'customTimeline' && (
    <>
      <CustomTimeline events={timelineEvents} />
      {isGuest() && <GuestOverlay />}
    </>
  )}
   {activeTab === 'myDecks' && (
    <>
      <MyDecks />
      {isGuest() && <GuestOverlay />}
    </>
  )} 
  {/* {activeTab === 'flashcards' && (
    <>
      <Flashcard events={timelineEvents} />
      {isGuest() && <GuestOverlay />}
    </>
  )} */}
  {/* {activeTab === 'quiz' && (
    <>
      <Quiz events={timelineEvents} />
      {isGuest() && <GuestOverlay />}
    </>
  )} */}
</div>
    </div>
  );
};

export default StudentDashboard;
